export default __webpack_public_path__ + "static/media/illustration-work-2-w@2x.15ba0be5.webp";